"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerPropMarket = void 0;
/**
 * Prop bet markets with data offered by PFF.
 */
var PlayerPropMarket;
(function (PlayerPropMarket) {
    /**
     * Pass Yardage
     */
    PlayerPropMarket["PassYardage"] = "PASS_YD";
    /**
     * Pass Touchdowns
     */
    PlayerPropMarket["PassTouchdowns"] = "PASS_TD";
    /**
     * Pass Attempts
     */
    PlayerPropMarket["PassAttempts"] = "PASS_ATT";
    /**
     * Pass Completions
     */
    PlayerPropMarket["PassCompletions"] = "PASS_COMP";
    /**
     * Pass Interceptions
     */
    PlayerPropMarket["PassInterceptions"] = "PASS_INT";
    /**
     * Receiving Receptions
     */
    PlayerPropMarket["ReceivingReceptions"] = "RECV_REC";
    /**
     * Receiving Targets
     */
    PlayerPropMarket["ReceivingTargets"] = "TARGETS";
    /**
     * Receiving Touchdown
     */
    PlayerPropMarket["ReceivingTouchDown"] = "RECV_TD";
    /**
     * Receiving Yardage
     */
    PlayerPropMarket["ReceivingYardage"] = "RECV_YD";
    /**
     * Rush Attempts
     */
    PlayerPropMarket["RushAttempts"] = "RUSH_ATT";
    /**
     * Rush Yardage
     */
    PlayerPropMarket["RushYardage"] = "RUSH_YD";
    /**
     * Rushing Touchdowns
     */
    PlayerPropMarket["RushTouchdowns"] = "RUSH_TD";
    /**
     * Rush Receiving Yardage
     */
    PlayerPropMarket["RushReceivingYardage"] = "RUSH_RECV_YD";
    /**
     * Anytime Touchdown
     */
    PlayerPropMarket["AnytimeTouchdown"] = "ANY_TIME_TD";
    /**
     * First Touchdown Scorer
     */
    PlayerPropMarket["FirstTouchdown"] = "FIRST_TD";
    /**
     * Last Touchdown Scorer
     */
    PlayerPropMarket["LastTouchdown"] = "LAST_TD";
    /**
     * Touchdown in the first half
     */
    PlayerPropMarket["FirstHalfTouchdown"] = "FIRST_HALF_TD";
    /**
     * Touchdown in the second half
     */
    PlayerPropMarket["SecondHalfTouchdown"] = "SECOND_HALF_TD";
    /**
     * First touchdown in the second half
     */
    PlayerPropMarket["FirstTdSecondHalf"] = "FIRST_TD_SECOND_HALF";
    /**
     * First Completion
     */
    PlayerPropMarket["FirstCompletion"] = "FIRST_COMPLETION";
    /**
     * Longest Pass
     */
    PlayerPropMarket["LongestPass"] = "LONGEST_PASS";
    /**
     * Longest Reception
     */
    PlayerPropMarket["LongestReception"] = "LONGEST_RECEPTION";
    /**
     * First Reception
     */
    PlayerPropMarket["FirstReception"] = "FIRST_RECEPTION";
    /**
     * Longest Rush
     */
    PlayerPropMarket["LongestRush"] = "LONGEST_RUSH";
    /**
     * First Rushing Attempt
     */
    PlayerPropMarket["FirstRushAtt"] = "FIRST_RUSH_ATT";
    /**
     * Tackles and Assists
     */
    PlayerPropMarket["TackleAssist"] = "TACKLE_ASSIST";
    /**
     * Sack
     */
    PlayerPropMarket["Sack"] = "SACK";
    /**
     * Kicking Points
     */
    PlayerPropMarket["KickPoints"] = "KICK_POINTS";
    /**
     * Alternate Passing Yards
     */
    PlayerPropMarket["AltPassYards"] = "ALT_PASS_YD";
    /**
     * Alternate Rushing Yards
     */
    PlayerPropMarket["AltRushYards"] = "ALT_RUSH_YD";
    /**
     * Alternate Receiving Yards
     */
    PlayerPropMarket["AltReceivingYards"] = "ALT_RECV_YD";
    /**
     * Passing and Rushing Yards
     */
    PlayerPropMarket["PassRushYardage"] = "PASS_RUSH_YD";
    /**
     * Defensive Player Interception.
     */
    PlayerPropMarket["DefenseInterception"] = "DEFENSE_INT";
    /**
     * Player to score 2+ touchdowns.
     */
    PlayerPropMarket["TwoPlusTouchdowns"] = "TWO_PLUS_TD";
    /**
     * Player to score 3+ touchdowns.
     */
    PlayerPropMarket["ThreePlusTouchdowns"] = "THREE_PLUS_TD";
    /**
     * Most passing yards in an event.
     */
    PlayerPropMarket["MostPassYardage"] = "MOST_PASS_YD";
    /**
     * Most rushing yards in an event.
     */
    PlayerPropMarket["MostRushYardage"] = "MOST_RUSH_YD";
    /**
     * First Team Touchdown Score
     */
    PlayerPropMarket["FirstTeamTouchdownScorer"] = "FIRST_TEAM_TD_SCORER";
})(PlayerPropMarket || (exports.PlayerPropMarket = PlayerPropMarket = {}));
//# sourceMappingURL=prop_markets.js.map